import React, { Component } from 'react';
import { Form, Modal, Input } from 'antd';
import './index.less';

const { Item } = Form;

class AddDeptModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      deptName: '',
    };

    this.handleCancel = this.handleCancel.bind(this);
    this.handleOk = this.handleOk.bind(this);
  }

  handleCancel() {
    const { handleCancel } = this.props;

    if (handleCancel) {
      handleCancel();
    }
  }

  handleOk() {
    const { form, handleAddDept } = this.props;

    const { validateFields } = form;

    validateFields((err, { deptName }) => {
      if (!err && handleAddDept) {
        handleAddDept({
          name: deptName,
        });
      }
    });
  }

  render() {
    const { form, extra = '', placeholder } = this.props;

    const { deptName } = this.state;

    const { getFieldDecorator, getFieldValue } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };

    const value = getFieldValue('deptName') || deptName || '';
    return (
      <Modal
        title="添加标签"
        centered
        visible
        onOk={this.handleOk}
        onCancel={this.handleCancel}
        className="modal-form-add"
        okButtonProps={{
          disabled: !value.trim().length || value.trim().length > 30,
        }}
      >
        <Form {...formItemLayout}>
          <Item
            label="标签名称"
            extra={extra}
            className={`form-dept-name form-dept-item ${deptName.length > 30 && 'error'}`}
            key="deptNameItem"
          >
            {getFieldDecorator('deptName', {
              initialValue: deptName,
              rules: [
                { required: true, message: '请输入标签名称' },
                { max: 30, message: '标签名称最大长度不能超过30个汉字' },
              ],
              onChange: e => this.setState({ deptName: e.target.value }),
            })(
              <Input
                placeholder={placeholder || '请输入标签名称 如：小学/民办/公办'}
                suffix={`${deptName.length || 0}/30`}
              />
            )}
          </Item>
        </Form>
      </Modal>
    );
  }
}

export default Form.create()(AddDeptModal);
